import React from "react";

export default function PopUpNewVersion({ version, date, changes, onClose }) {
  return (
    <div
      className="fixed right-6 bottom-6 z-50 bg-white dark:bg-gray-900 shadow-2xl rounded-2xl min-w-[320px] max-w-xs sm:max-w-sm p-6 font-sans text-gray-900 dark:text-gray-100 animate-slideIn border border-gray-200 dark:border-gray-700"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between mb-2">
        <div className="font-bold text-lg flex items-center gap-2">
          <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" /></svg>
          Nouvelle version !
        </div>
        <button
          onClick={onClose}
          className="ml-2 text-2xl leading-none text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 focus:outline-none"
          aria-label="Fermer"
        >
          &times;
        </button>
      </div>
      <div className="text-sm text-gray-600 dark:text-gray-300 mb-1">
        <span className="font-semibold">Version :</span> {version}
      </div>
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        <span className="font-semibold">Date :</span> {date}
      </div>
      <div className="mt-2">
        <div className="font-semibold mb-1 text-sm">Modifications :</div>
        <ul className="list-disc pl-5 space-y-1 text-sm">
          {changes && changes.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
